import { React, PT, withRouter, connect } from '@gasbuddy/react';
import ReactS3Uploader from 'react-s3-uploader';
import { Grid, Container, Button, Loader } from 'semantic-ui-react';
import { Auth, Nav, BrandInfo, BrandEdit } from '../../components';
import { Role } from '../../roles';
import { Action } from '../../reducers/actions';
import { fetch } from '../../../client/lib/fetch';

const VERIFY_INTERVAL_MS = 2000;
const VERIFY_MAX_ATTEMPTS = 10;

function getBrandId({ match: { params: { brandId } } }) {
  return brandId;
}

class BrandPage extends React.Component {
  state = {
    editing: false,
    brandId: getBrandId(this.props),
    brand: {
      uploadStatus: null,
    },
  };

  componentDidMount() {
    const { dispatch } = this.props;
    const { brandId } = this.state;
    dispatch({
      type: Action.Poi.BrandRequested,
      meta: { apiAction: true },
      payload: {
        url: `/poi/brand/${brandId || '0'}`,
      },
    });
  }

  componentWillReceiveProps(nextProps) {
    const { uploadStatus: nextStatus, incrementFailed: nextIncrementFailed } = nextProps.brand;
    this.setState(prev => ({
      brand: {
        uploadStatus: nextStatus,
        incrementFailed: nextIncrementFailed,
        verifyStatus: prev.brand.verifyStatus,
      },
    }));
  }

  componentWillUnmount() {
    if (this.verifyTimer) {
      clearTimeout(this.verifyTimer);
      this.verifyTimer = null;
    }
  }

  toggleEditing = () => {
    const { editing, brandId, brand: stateBrand } = this.state;
    const { brand, dispatch } = this.props;
    this.setState({
      editing: !editing,
      brand: brand.brand,
    });
    // TODO which version of editing did you intend to capture?
    if (editing) {
      // Save changes
      dispatch({
        type: Action.Poi.BrandUpdateRequested,
        meta: { apiAction: true },
        payload: {
          url: `/poi/brand/save/${brandId}`,
          body: stateBrand,
        },
      });
    }
  }

  editHandlerFactory = (name, type) => {
    const theName = name;
    const theType = type;
    return function eventHandler(e, result) {
      const { brand } = this.state;
      const stateChange = { brand };
      if (theType === 'string') { stateChange.brand[theName] = result.value; }
      if (theType === 'bool') { stateChange.brand[theName] = (theName === 'allow_brand_sharing') ? !result.checked : result.checked; }
      this.setState(stateChange);
    }.bind(this);
  }

  waitForLambdaThenIncrement = () => {
    if (this.verifyTimer) {
      clearTimeout(this.verifyTimer);
      this.verifyTimer = null;
    }
    this.verifyAttempts = 0;
    this.uploadStartTime = Date.now();
    this.setState(prev => ({
      brand: {
        ...prev.brand,
        uploadStatus: 'Waiting for resize cleanup...',
        verifyStatus: 'verifying',
      },
    }));
    this.pollVerify();
  }

  incrementBrandLogoVersion = () => {
    this.setState({ brand: { uploadStatus: 'Updating logo version...', incrementFailed: false, verifyStatus: null } });
    const { dispatch } = this.props;
    const { brandId } = this.state;
    dispatch({
      type: Action.Poi.BrandLogoIncrementRequested,
      meta: { apiAction: true },
      payload: {
        url: `/poi/brand/increment-logo-version/${brandId}`,
      },
    });
  }

  pollVerify = () => {
    const { brandId } = this.state;
    const since = this.uploadStartTime || 0;
    fetch(`/poi/brand/verify-logo/${brandId}?since=${since}`)
      .then(({ body }) => this.handleVerifyResult(!!(body && body.ok)))
      .catch(() => this.handleVerifyResult(false));
  }

  handleVerifyResult = (ok) => {
    this.verifyAttempts = (this.verifyAttempts || 0) + 1;
    if (ok) {
      this.setState(prev => ({ brand: { ...prev.brand, verifyStatus: 'verified' } }));
      this.incrementBrandLogoVersion();
      return;
    }
    if (this.verifyAttempts >= VERIFY_MAX_ATTEMPTS) {
      this.setState(prev => ({ brand: { ...prev.brand, verifyStatus: 'failed', uploadStatus: null } }));
      return;
    }
    this.verifyTimer = setTimeout(this.pollVerify, VERIFY_INTERVAL_MS);
  }

  retryUpload = () => {
    this.setState(prev => ({ brand: { ...prev.brand, verifyStatus: null, uploadStatus: null } }));
    if (this.uploadInput) { this.uploadInput.click(); }
  }

  render() {
    let { brand: { brand } } = this.props;
    if (!brand) brand = BrandPage.defaultProps;
    const { editing, brandId, brand: stateBrand } = this.state;
    return (
      <Auth forRoles={[Role.AnyAdmin]}>
        <Nav>
          {(editing
            && <BrandEdit brand={brand} editHandler={this.editHandlerFactory} />)
            || <BrandInfo brand={brand} />}
          <Auth forActions={[Role.POI]} hideUnauthorized>
            <Grid columns={16}>
              <Grid.Row>
                <Grid.Column width={6} />
                <Grid.Column width={4}>
                  <Container style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button onClick={this.toggleEditing}>{editing ? 'Save' : 'Edit'}</Button>
                  </Container>
                </Grid.Column>
                <Grid.Column width={6} />
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} />
                <Grid.Column width={4}>
                  <Container style={{ display: 'flex', justifyContent: 'center' }}>
                    Upload New Brand Logo (Current version:
                    {' '}
                    {brand.logo_version || 'N/A'}
):
                  </Container>
                  <Container style={{ display: 'flex', justifyContent: 'center' }}>
                    <ReactS3Uploader
                      signingUrl="../s3_sign_brand_logo"
                      signingUrlMethod="GET"
                      accept="image/png"
                      onError={errorMessage => this.setState({ brand: { uploadStatus: `Error: ${errorMessage}` } })}
                      onFinish={this.waitForLambdaThenIncrement}
                      onProgress={(percent, message) => this.setState({ brand: { uploadStatus: `${Math.min(percent, 99)}% Complete - ${message}` } })}
                      contentDisposition="auto"
                      uploadRequestHeaders={{ 'x-amz-acl': 'private' }}
                      scrubFilename={() => `${brandId}.png`}
                      inputRef={(cmp) => { this.uploadInput = cmp; }}
                    />
                    {stateBrand.uploadStatus || ''}
                    {(stateBrand.incrementFailed || stateBrand.verifyStatus === 'failed')
                      && (
                        <Button
                          size="mini"
                          onClick={stateBrand.incrementFailed ? this.incrementBrandLogoVersion : this.retryUpload}
                          style={{ marginLeft: '8px' }}
                        >
                          Retry
                        </Button>
                      )}
                  </Container>
                  <Container>
                    {stateBrand.verifyStatus === 'verifying' && (
                      <span>
                        <Loader active inline size="tiny" style={{ marginRight: '8px' }} />
                        Waiting for resize cleanup before bumping version...
                      </span>
                    )}
                    {stateBrand.verifyStatus === 'failed' && 'Resize cleanup did not complete in time.'}
                  </Container>
                  <Container>
                    {(stateBrand.uploadStatus || '').startsWith('100%')
                      ? 'Note: It may take up to 4 hours for this new logo to update everywhere it appears.' : ''
                    }
                  </Container>
                </Grid.Column>
                <Grid.Column width={6} />
              </Grid.Row>
            </Grid>
          </Auth>
        </Nav>
      </Auth>
    );
  }
}

const mapStateToProps = state => state;

export const Brand = withRouter(connect(mapStateToProps)(BrandPage));

BrandPage.defaultProps = {
  brand: PT.shape({
    brand: PT.shape({
      brand_id: 0,
      name: '',
      logo_version: 1,
      image_url: '',
      description: '',
    }),
    uploadStatus: null,
  }),
};

BrandPage.propTypes = {
  dispatch: PT.func.isRequired,
  match: PT.shape({
    params: PT.shape({
      brandId: PT.string,
    }),
  }).isRequired,
  brand: PT.shape({
    brand: PT.shape({
      brand_id: PT.number,
      name: PT.string,
      logo_version: PT.number,
      image_url: PT.string,
      description: PT.string,
      is_fuel: PT.boolean,
      is_cstore: PT.boolean,
      allow_sharing: PT.boolean,
      display: PT.boolean,
    }),
    uploadStatus: PT.string,
    incrementFailed: PT.bool,
  }),
};
